export class AnnexurePrintConfig {
    withOtherWorks: boolean;
    withUnits: boolean;
    preview: boolean;
}